import { useGetDefaultSectionConfigsQuery } from '../../__generated__/chirp/com/hubspot/crm/pipeline/board/configuration/rpc/CrmPipelineBoardConfigurationService.hooks';
import { useMemo } from 'react';
import { getFormattedSectionSettings } from './utils';
import { useObjectTypeId } from 'crm-object-board-core/objectTypeDefinition';
import { useHasCardV2 } from 'crm-object-board-core/hooks';
import { useSelectedPipelineIdByAccess } from '../hooks/useSelectedPipelineIdByAccess';
import { useAppId } from '../hooks/useAppId';
export const useDefaultCardSectionSettings = () => {
  const hasCardV2 = useHasCardV2();
  const objectTypeId = useObjectTypeId();
  const pipelineId = useSelectedPipelineIdByAccess();
  const appId = useAppId();
  const {
    loading,
    error,
    data: apiData
  } = useGetDefaultSectionConfigsQuery({
    skip: !hasCardV2,
    variables: {
      pipelineId,
      objectTypeId,
      appId
    }
  });
  const formattedSettings = useMemo(() => {
    var _apiData$boardCardSec;
    return getFormattedSectionSettings((_apiData$boardCardSec = apiData === null || apiData === void 0 ? void 0 : apiData.boardCardSectionConfigurations) !== null && _apiData$boardCardSec !== void 0 ? _apiData$boardCardSec : []);
  }, [apiData]);
  if (error || loading) {
    return {
      data: [],
      loading,
      error
    };
  }
  return {
    data: formattedSettings,
    loading,
    error
  };
};